import React, { useEffect, useState } from 'react';

import { IConsultantTileSmall } from 'components/static/ConsultantTileSmall';

import createConsultantTilesSmall from 'utils/createConsultantTilesSmall';

import { ERoute } from '../types/enums/ERoute';
import { EUrlSearchParam } from '../types/enums/EUrlSearchParam';
import getAllConsultants from './sulu/getAllConsultants';
import getConsultant from './sulu/getConsultant';
import getConsultantList from './sulu/getConsultantList';

interface SuitableConsultantsProps {
  headlineSuitableConsultants: string;
  suitableConsultants: string;
}

const SuitableConsultants: React.FC<SuitableConsultantsProps> = ({
  headlineSuitableConsultants,
  suitableConsultants,
}) => {
  const [suitableConsultantTiles, setSuitableConsultantTiles] = useState<
    IConsultantTileSmall[]
  >([]);
  const [filterId, setFilterId] = useState<number[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [allConsultants, listResponse] = await Promise.all([
          getAllConsultants(),
          getConsultantList(),
        ]);

        if (!listResponse) return;

        const profilePromises = listResponse.map(c => getConsultant(c.id));
        const fullProfiles = await Promise.all(profilePromises);

        const suitableArray = suitableConsultants
          .split(',')
          .map(s => s.trim().toLowerCase());

        const filteredProfiles = fullProfiles.filter(
          (profile): profile is any => {
            if (!profile) return false;

            const email = (profile?.email || '').toLowerCase();
            const id = String(profile?.id).toLowerCase();
            const categories = (
              profile?.consultantDetails?.categories || []
            ).map(c => c.toLowerCase());

            return (
              suitableArray.includes(email) ||
              suitableArray.includes(id) ||
              categories.some(cat => suitableArray.includes(cat))
            );
          },
        );

        const filteredIds = filteredProfiles.map(p => p.id);

        const tiles = allConsultants
          .filter(c => filteredIds.includes(c.id))
          .map(c => ({
            id: c.id,
            name: c.name || '',
            url: `/${ERoute.CONSULTANT_PROFILE}?${EUrlSearchParam.CONSULTANT_ID}=${c.id}`,
            profileImageUrl: c.avatar || '',
          }));

        setSuitableConsultantTiles(tiles);
        setFilterId(filteredIds);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Fehler beim Laden der Consultants:', error);
      }
    };

    if (suitableConsultants) {
      fetchData().then();
    }
  }, [suitableConsultants]);

  return (
    <div>
      {suitableConsultants && (
        <div className='mt-6'>
          <h3>{headlineSuitableConsultants}</h3>
          <div className='flex items-center justify-center flex-wrap gap-5 mt-5'>
            {createConsultantTilesSmall(
              suitableConsultantTiles.filter(tile =>
                filterId.includes(tile.id),
              ),
              filterId,
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SuitableConsultants;
